'use strict';

var EffectType = /* @__PURE__ */ ((EffectType2) => {
  EffectType2[EffectType2["account_created"] = 0] = "account_created";
  EffectType2[EffectType2["account_removed"] = 1] = "account_removed";
  EffectType2[EffectType2["account_credited"] = 2] = "account_credited";
  EffectType2[EffectType2["account_debited"] = 3] = "account_debited";
  EffectType2[EffectType2["account_thresholds_updated"] = 4] = "account_thresholds_updated";
  EffectType2[EffectType2["account_home_domain_updated"] = 5] = "account_home_domain_updated";
  EffectType2[EffectType2["account_flags_updated"] = 6] = "account_flags_updated";
  EffectType2[EffectType2["account_inflation_destination_updated"] = 7] = "account_inflation_destination_updated";
  EffectType2[EffectType2["signer_created"] = 10] = "signer_created";
  EffectType2[EffectType2["signer_removed"] = 11] = "signer_removed";
  EffectType2[EffectType2["signer_updated"] = 12] = "signer_updated";
  EffectType2[EffectType2["trustline_created"] = 20] = "trustline_created";
  EffectType2[EffectType2["trustline_removed"] = 21] = "trustline_removed";
  EffectType2[EffectType2["trustline_updated"] = 22] = "trustline_updated";
  EffectType2[EffectType2["trustline_authorized"] = 23] = "trustline_authorized";
  EffectType2[EffectType2["trustline_deauthorized"] = 24] = "trustline_deauthorized";
  EffectType2[EffectType2["trustline_authorized_to_maintain_liabilities"] = 25] = "trustline_authorized_to_maintain_liabilities";
  EffectType2[EffectType2["trustline_flags_updated"] = 26] = "trustline_flags_updated";
  EffectType2[EffectType2["offer_created"] = 30] = "offer_created";
  EffectType2[EffectType2["offer_removed"] = 31] = "offer_removed";
  EffectType2[EffectType2["offer_updated"] = 32] = "offer_updated";
  EffectType2[EffectType2["trade"] = 33] = "trade";
  EffectType2[EffectType2["data_created"] = 40] = "data_created";
  EffectType2[EffectType2["data_removed"] = 41] = "data_removed";
  EffectType2[EffectType2["data_updated"] = 42] = "data_updated";
  EffectType2[EffectType2["sequence_bumped"] = 43] = "sequence_bumped";
  EffectType2[EffectType2["claimable_balance_created"] = 50] = "claimable_balance_created";
  EffectType2[EffectType2["claimable_balance_claimant_created"] = 51] = "claimable_balance_claimant_created";
  EffectType2[EffectType2["claimable_balance_claimed"] = 52] = "claimable_balance_claimed";
  EffectType2[EffectType2["account_sponsorship_created"] = 60] = "account_sponsorship_created";
  EffectType2[EffectType2["account_sponsorship_updated"] = 61] = "account_sponsorship_updated";
  EffectType2[EffectType2["account_sponsorship_removed"] = 62] = "account_sponsorship_removed";
  EffectType2[EffectType2["trustline_sponsorship_created"] = 63] = "trustline_sponsorship_created";
  EffectType2[EffectType2["trustline_sponsorship_updated"] = 64] = "trustline_sponsorship_updated";
  EffectType2[EffectType2["trustline_sponsorship_removed"] = 65] = "trustline_sponsorship_removed";
  EffectType2[EffectType2["data_sponsorship_created"] = 66] = "data_sponsorship_created";
  EffectType2[EffectType2["data_sponsorship_updated"] = 67] = "data_sponsorship_updated";
  EffectType2[EffectType2["data_sponsorship_removed"] = 68] = "data_sponsorship_removed";
  EffectType2[EffectType2["claimable_balance_sponsorship_created"] = 69] = "claimable_balance_sponsorship_created";
  EffectType2[EffectType2["claimable_balance_sponsorship_updated"] = 70] = "claimable_balance_sponsorship_updated";
  EffectType2[EffectType2["claimable_balance_sponsorship_removed"] = 71] = "claimable_balance_sponsorship_removed";
  EffectType2[EffectType2["signer_sponsorship_created"] = 72] = "signer_sponsorship_created";
  EffectType2[EffectType2["signer_sponsorship_updated"] = 73] = "signer_sponsorship_updated";
  EffectType2[EffectType2["signer_sponsorship_removed"] = 74] = "signer_sponsorship_removed";
  EffectType2[EffectType2["claimable_balance_clawed_back"] = 80] = "claimable_balance_clawed_back";
  EffectType2[EffectType2["liquidity_pool_deposited"] = 90] = "liquidity_pool_deposited";
  EffectType2[EffectType2["liquidity_pool_withdrew"] = 91] = "liquidity_pool_withdrew";
  EffectType2[EffectType2["liquidity_pool_trade"] = 92] = "liquidity_pool_trade";
  EffectType2[EffectType2["liquidity_pool_created"] = 93] = "liquidity_pool_created";
  EffectType2[EffectType2["liquidity_pool_removed"] = 94] = "liquidity_pool_removed";
  EffectType2[EffectType2["liquidity_pool_revoked"] = 95] = "liquidity_pool_revoked";
  EffectType2[EffectType2["contract_credited"] = 96] = "contract_credited";
  EffectType2[EffectType2["contract_debited"] = 97] = "contract_debited";
  return EffectType2;
})(EffectType || {});

exports.EffectType = EffectType;
//# sourceMappingURL=effects.js.map
